import React, { FC } from 'react';
import { Announcement as AnnouncementType } from '@mnspro-cloud/teams-services';
import { useTranslation } from 'react-i18next';
import { Text } from '../../Text/Text';
import cn from 'classnames';
import { MegaphoneRegular } from '@fluentui/react-icons';
import './AnnouncementsWidget.scss';
import {
  AnnouncementBasicResponse,
  AnnouncementResponse,
} from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';
import { WidgetsHeadline } from '../WidgetsHeadline/WidgetsHeadline';
import { Announcement as AnnouncementComponent } from './Announcement';
import { AnnouncementsWidgetSkeleton } from './AnnouncementsWidgetSkeleton';

export interface AnnouncementsWidgetProps {
  isLoading: boolean;
  announcements: AnnouncementType[] | AnnouncementResponse[] | AnnouncementBasicResponse[];
  error?: Error | null;
  classNames?: string;
}

export const AnnouncementsWidget: FC<AnnouncementsWidgetProps> = ({
  isLoading,
  announcements,
  error,
  classNames,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {(isLoading || announcements.length > 0 || error) && (
        <div className={cn('announcementsWidget', classNames)}>
          <WidgetsHeadline
            content={t('dashboard:announcements:headline', { defaultValue: 'Ankündigungen' })}
            icon={<MegaphoneRegular fontSize={24} />}
          />
          <div className="announcementsBody">
            {isLoading && <AnnouncementsWidgetSkeleton />}
            {!isLoading && error && (
              <Text color="danger">
                {t('dashboard:announcements:errorMessageText', { defaultValue: 'Fehler beim Laden der Ankündigungen' })}
              </Text>
            )}
            {!isLoading &&
              !error &&
              announcements.map(announcement => (
                <AnnouncementComponent key={announcement.id} announcement={announcement} />
              ))}
          </div>
        </div>
      )}
    </>
  );
};
